import { InjectionToken } from '@angular/core';

/**
 * Used to provide a parser that can be used with the MarkdownService
 * to parse markdown input into HTML
 */
export const LEGACY_FRAMEWORK = new InjectionToken<boolean>('LEGACY_FRAMEWORK');
